<template>
    <v-snackbar
      v-model="show"
      :color="toastColor"
      absolute
      location="top right"
      style="top:70px;right: 30px;z-index: 4000"
    >
      {{ $store.state.notificationMsg.content }}
    </v-snackbar>
</template>
<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Notification',
  props: {},
  data() {
    return {
      show: false,
      config: {},
      toastColor: 'info',
    }
  },
  created() {
    window.Notification = this
  },
  mounted() {
  },
  watch: {
    '$store.state.notificationMsg.updateTime': function() {
      const notificationMsg = this.$store.state.notificationMsg
      this.show = false
      clearTimeout(window._notificationTimeout)
      if (notificationMsg.content) {
        this.show = true
        this.toastColor = notificationMsg.type === 'warning' ? 'error' : 'info'
        window._notificationTimeout = setTimeout(() => {
          this.show = false
        }, 3000)
      }
    },
  },
})
</script>
<style scoped lang="scss">

</style>
